import React from "react"
import { Button } from "reactstrap"
import { AnalyseExecutionResponse } from "../types"

const KeyphraseSection: React.FC<{
  analyseResponse?: AnalyseExecutionResponse;
  handleKeyPhrase: (p: string) => void;
}> = ({ analyseResponse: executionInfo, handleKeyPhrase }) => {

  return (
    <>
      <div className="mb-3">
        <h2 style={{ display: 'inline' }}>
          Key Phrases
        </h2>
      </div>
      <div>
        {
          executionInfo?.keyphrases?.map((kp, i) => (
            <Button key={i} className="mr-2 mb-2" color="primary" size="sm" onClick={() => {
              handleKeyPhrase(kp)
            }}>
              {kp}
            </Button>
          ))
        }
      </div>
    </>
  )
}

export default KeyphraseSection
